// src/services/FirestoreServices.js
import React from "react";
import {
  collection,
  addDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  doc,
  setDoc,
  getDoc,
  where,
  deleteDoc,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../firebase";

/**
 * createSubmission
 * Creates a submission document when a user publishes a folder for admin review.
 */
export async function createSubmission(userId, folderId) {
  try {
    const submissionsRef = collection(db, "submissions");

    // Fetch user document to get fullName
    const userDocRef = doc(db, "users", userId);
    const userDocSnap = await getDoc(userDocRef);
    const userData = userDocSnap.exists() ? userDocSnap.data() : {};
    const fullName = userData.fullName || null;

    // Fetch folder document to get folderName
    const folderDocRef = doc(db, "users", userId, "folders", folderId);
    const folderDocSnap = await getDoc(folderDocRef);
    const folderData = folderDocSnap.exists() ? folderDocSnap.data() : {};
    const folderName = folderData.folderName || null;

    await updateDoc(folderDocRef, {
      status: "pending",
      adminNotes: "",
      approvedAt: null,
      approvedBy: null,
      rejectedAt: null,
      rejectedBy: null,
      adminAvatarPath: null,
      // Optionally clear any other admin-only metadata (attachments, etc)
    });

    const submissionData = {
      userId,
      folderId,
      fullName,
      folderName,
      status: "pending",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      adminNotes: "",
    };
    const submissionDocRef = await addDoc(submissionsRef, submissionData);

    // Add initial log entry to centralized logs collection
    const logsRef = collection(db, "submission_logs");
    await addDoc(logsRef, {
      submissionId: submissionDocRef.id,
      userId,
      action: "submitted",
      timestamp: serverTimestamp(),
      details: `Folder ${folderId} submitted by user ${userId}`,
    });

    // Update user folder status to pending
    await updateDoc(folderDocRef, {
      status: "pending",
      adminNotes: "",
    });

    return submissionDocRef.id;
  } catch (error) {
    console.error("Error creating submission:", error);
    throw error;
  }
}
